import { render, staticRenderFns } from "./Atendimento.vue?vue&type=template&id=3e6a9f98&scoped=true"
import script from "./Atendimento.vue?vue&type=script&lang=js"
export * from "./Atendimento.vue?vue&type=script&lang=js"
import style0 from "./Atendimento.vue?vue&type=style&index=0&id=3e6a9f98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6a9f98",
  null
  
)

export default component.exports